import React from 'react';
import Alert from '@material-ui/core/Alert';
import { Box } from '@material-ui/core'
import DominioNoDisponible from './DominioNoDisponible';
import AvailableDomain from './AvailableDomain';
import { useTranslation } from 'react-i18next';

function VerifyDomainOnly(props) {
    const {t} = useTranslation();
    const status = props.domainstatus;
    const domain = props.inputdomain;
    const tld = props.tld;
    const eventDomain = props.eventDomain;
    const epp = props.epp;
    const curcode =  props.curcode;

    if (eventDomain === 'domainregister') {
        if (status === 'available') {
            return <AvailableDomain dominio={domain} tld={tld} eventDomain={eventDomain} epp={epp} curcode={curcode} />;
        }
        if (status === 'regthroughus' || status === 'regthroughothers' || status === 'unknown') {
            return <DominioNoDisponible dominio={domain} eventDomain={eventDomain} />;
        }
    }
    if (eventDomain === 'domaintransfer') {
        if (status === 'regthroughothers') {
            return <AvailableDomain dominio={domain} tld={tld} eventDomain={eventDomain} epp={epp} />;
        }
        if (status === 'available' || status === 'regthroughus' || status === 'unknown') {
            return <DominioNoDisponible dominio={domain} eventDomain={eventDomain} />;
        }
    }

    return (
        <Box mt={3}>
            <Alert severity="info">{t('enterDomain')}</Alert>
        </Box>
    )
}

export default VerifyDomainOnly;